import { Injectable } from '@angular/core';
import { MsalAccountService } from '../services/msal-account/msal-account.service';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BerriaGuard implements CanActivate {
  constructor(
    private _msalAccountService: MsalAccountService,
    private router: Router
  ) {}
  canActivate(): boolean {
    const account = this._msalAccountService.getAccountInfo();
    const roles = account?.idTokenClaims?.roles;

    if (roles.includes("espdvsales.berria")) {
      console.log("Redirect to berriaCare", roles)
      this.router.navigate(['/berriaCare']);
    } else {
      console.log("Redirect to calculator", roles)
      this.router.navigate(['/calculator']);
    }
    return false;
  }
}
